import React, { useState, useEffect } from "react";
import { Button } from "./ui";
import MapViewMapeo from "./MapViewMapeo";

const ModalMapeo = ({ partido, onSave, initialData, initialDataParcelas, initialParcelasMetadata, disabled, sinSede = false }) => {
    const [isOpen, setIsOpen] = useState(false);
    // Estado para guardar temporalmente lo que el usuario dibuja
    const [tempFeatures, setTempFeatures] = useState({
        geom_sede: initialData || null,
        geom_parcelas: initialDataParcelas || [],
        parcelas_metadata: initialParcelasMetadata || []
    });

    //Agregar cambio:
    const [ubicacion, setUbicacion] = useState(null);
    const [parcelas, setParcelas] = useState([]);

	// Reforzar la lógica interna de deshabilitado
    const isButtonDisabled = disabled || !partido || partido === "0" || partido === "";

	// Sincronizar si initialData cambia externamente
    useEffect(() => {
        setTempFeatures({
            geom_sede: initialData, 
            geom_parcelas: initialDataParcelas,
            parcelas_metadata: initialParcelasMetadata
        });
    }, [initialData, initialDataParcelas, initialParcelasMetadata]);

    const handleOpen = () => { //Nunca deberia ejecutarse, no deberia habilitarse el button si no hay partido
        if (!partido) {
            alert("Por favor, seleccione un partido primero para centrar el mapa.");
            return;
        }
        setIsOpen(true);
    };

	// Función para verificar si realmente hay geometrías
	/*const hasGeometries = (geojson) => {
		return geojson && geojson.features && geojson.features.length > 0;
	};*/
    // Función auxiliar para determinar qué geometrías existen
    const getGeometryStatus = (data) => {
        console.log("DEBUG getGeometryStatus data:", data);
        if (!data) return { hasSede: false, hasParcelas: false, count: 0 };
        
        // Verificar geom_sede (puede ser array [lon, lat], string JSON, o GeoJSON Feature)
        let hasSede = false;
        if (data.geom_sede) {
            // Formato 1: Array [lon, lat]
            if (Array.isArray(data.geom_sede) && data.geom_sede.length === 2) {
                hasSede = true;
                console.log("DEBUG: Sede detectada como array [lon, lat]");
            } 
            // Formato 2: String JSON (Point o Feature)
            else if (typeof data.geom_sede === 'string') {
                try {
                    const parsed = JSON.parse(data.geom_sede);
                    if (parsed.type === 'Point' && Array.isArray(parsed.coordinates)) {
                        hasSede = true;
                        console.log("DEBUG: Sede detectada como GeoJSON Point");
                    } else if (parsed.type === 'Feature' && parsed.geometry?.type === 'Point') {
                        hasSede = true;
                        console.log("DEBUG: Sede detectada como GeoJSON Feature con Point");
                    }
                } catch (e) {
                    console.log("DEBUG: Error parseando geom_sede:", e);
                    hasSede = false;
                }
            }
            // Formato 3: Objeto GeoJSON directo (Point o Feature)
            else if (typeof data.geom_sede === 'object') {
                if (data.geom_sede.type === 'Point' && Array.isArray(data.geom_sede.coordinates)) {
                    hasSede = true;
                    console.log("DEBUG: Sede detectada como objeto GeoJSON Point");
                } else if (data.geom_sede.type === 'Feature' && data.geom_sede.geometry?.type === 'Point') {
                    hasSede = true;
                    console.log("DEBUG: Sede detectada como objeto GeoJSON Feature");
                }
            }
        }
        
        // Verificar geom_parcelas - puede venir en TRES formatos:
        // 1. Array de objetos: [{geometry: GeoJSON, partida: ..., parcela: ...}]
        // 2. Array de GeoJSON directo: [GeoJSON, GeoJSON, ...]
        // 3. Array de strings JSON: ['{"type":"Polygon",...}', '{"type":"Polygon",...}']
        const parcelasRaw = data.geom_parcelas && Array.isArray(data.geom_parcelas) ? data.geom_parcelas : [];
        const parcelasCount = parcelasRaw.filter(p => {
            if (!p) return false;
            // Formato 3: String JSON
            if (typeof p === 'string') {
                try {
                    const parsed = JSON.parse(p);
                    return parsed && parsed.type && (parsed.coordinates || parsed.geometry);
                } catch (e) {
                    return false;
                }
            }
            // Formato 1: objeto con propiedad geometry
            if (p.geometry !== undefined) {
                const geom = p.geometry;
                if (geom === null) return false;
                if (typeof geom === 'string') {
                    return geom.trim() !== '' && geom !== 'null';
                }
                if (typeof geom === 'object') {
                    return !!geom.type;
                }
                return false;
            }
            // Formato 2: GeoJSON directo (tiene type y coordinates)
            if (p.type && (p.coordinates || p.geometry)) {
                return true;
            }
            return false;
        }).length;
        const hasParcelas = parcelasCount > 0;
        
        const result = { hasSede, hasParcelas, count: (hasSede ? 1 : 0) + parcelasCount, parcelasCount };
        console.log("DEBUG getGeometryStatus resultado:", result);
        return result;
    };

    const hasGeometries = (data) => {
        const status = getGeometryStatus(data);
        return status.hasSede || status.hasParcelas;
    };

    const handleConfirmar = () => {
        // Al confirmar, enviamos los datos temporales al contexto del TabA
        const dataToSave = {
            ...tempFeatures,
            geom_sede: sinSede ? null : tempFeatures?.geom_sede
        };
        if (onSave) {
            onSave(dataToSave);
        }
        setIsOpen(false);
    };

    const handleCancelar = () => {
        // Simplemente cerramos sin ejecutar onSave (descarta cambios)
        setIsOpen(false);
    };

    const handleFeatureDataChange = (updatedGeoJSON) => {
        console.log("QUE LLEGA en handleFeatureDataChange", updatedGeoJSON);
        setTempFeatures({
            ...updatedGeoJSON,
            geom_sede: sinSede ? null : updatedGeoJSON.geom_sede
        });
    };

    // Calcular status para usar en className
    const buttonStatus = getGeometryStatus(tempFeatures);

    return (
        <>
            <Button
                onClick={handleOpen}
                disabled={disabled || !partido}
                variant={hasGeometries(tempFeatures) ? 'subse_green' : 'subse'}
                className="w-fit flex items-center gap-2 px-4 py-2 font-bold shadow-md hover:shadow-lg rounded-md ml-auto"
                style={{ width: 'fit-content', maxWidth: '300px' }}
            >
                {(() => {
                    const status = getGeometryStatus(tempFeatures);
                    if (sinSede) {
                        if (!status.hasParcelas) return '🗺️ Mapear Parcelas';
                        return `📍 ${status.parcelasCount} parcela${status.parcelasCount > 1 ? 's' : ''}`;
                    }
                    if (!status.hasSede && !status.hasParcelas) return '🗺️ Mapear Entidad';
                    if (status.hasSede && status.hasParcelas) return `📍 Sede + ${status.parcelasCount} parcela${status.parcelasCount > 1 ? 's' : ''}`;
                    if (status.hasSede) return '📍 Sede lista - Falta parcela';
                    return ` Falta sede -📍 ${status.parcelasCount} parcela${status.parcelasCount > 1 ? 's' : ''}`;
                })()}
            </Button>

            {isOpen && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/70 backdrop-blur-sm p-4">
                    <div className="bg-white w-[95vw] h-[90vh] rounded-2xl flex flex-col shadow-2xl border border-slate-200 overflow-hidden">
                        
                        {/* Header Estilizado */}
                        <div className="p-4 bg-slate-50 border-b flex justify-between items-center">
                            <div>
                                <h2 className="font-black text-slate-800 uppercase tracking-tight">Georreferenciación</h2>
                                <p className="text-[10px] text-blue-600 font-bold uppercase">Partido: {partido}</p>
                            </div>
                            <button onClick={handleCancelar} className="text-slate-400 hover:text-slate-600 text-2xl px-2">✕</button>
                        </div>

                        {/* Cuerpo del Mapa */}
                        <div className="flex-grow relative bg-slate-100">
                            {/*<MapView 
                                partido={partido} 
                                // Cada vez que el usuario dibuja o mueve un punto, actualizamos el temporal
                                onFeatureDataChange={handleFeatureDataChange}
                                initialFeatures={tempFeatures}
                            />*/}
							<MapViewMapeo
								partido={partido}
								initialFeatures={initialData}
                                initialFeaturesParcelas={initialDataParcelas}
                                initialParcelasMetadata={initialParcelasMetadata}
                                sinSede={sinSede}
								onFeatureDataChange={handleFeatureDataChange}
							/>
                        </div>

                        {/* Footer con Acciones Claras */}
                        <div className="p-3 bg-slate-50 border-t flex justify-between items-center gap-4">
                            <button 
                                onClick={() => setIsOpen(false)}
                                className="px-4 py-2 bg-gray-500 hover:bg-gray-600 text-white rounded-md transition-colors text-sm font-semibold"
                            >
                                Cancelar
                            </button>

                            <div className="flex items-center gap-3">
                                {/* Indicador de estado compacto */}
                                {(() => {
                                    const status = getGeometryStatus(tempFeatures);
                                    if (sinSede) {
                                        if (!status.hasParcelas) {
                                            return (
                                                <span className="text-[10px] font-bold text-slate-400 uppercase italic">
                                                    Sin parcelas
                                                </span>
                                            );
                                        }
                                        return (
                                            <span className="text-[10px] font-bold text-green-600 uppercase">
                                                ● {status.parcelasCount} parcela{status.parcelasCount > 1 ? 's' : ''}
                                            </span>
                                        );
                                    }
                                    if (!status.hasSede && !status.hasParcelas) {
                                        return (
                                            <span className="text-[10px] font-bold text-slate-400 uppercase italic">
                                                Sin geometrías
                                            </span>
                                        );
                                    }
                                    if (status.hasSede && status.hasParcelas) {
                                        return (
                                            <span className="text-[10px] font-bold text-green-600 uppercase">
                                                ● Sede + {status.count - 1} parcela{status.count > 2 ? 's' : ''}
                                            </span>
                                        );
                                    }
                                    if (status.hasSede) {
                                        return (
                                            <span className="text-[10px] font-bold text-green-600 uppercase">
                                                ● Sede
                                            </span>
                                        );
                                    }
                                    return (
                                        <span className="text-[10px] font-bold text-green-600 uppercase">
                                            ● {status.count} parcela{status.count > 1 ? 's' : ''}
                                        </span>
                                    );
                                })()}
                                <button 
                                    onClick={handleConfirmar}
                                    className="px-6 py-2 bg-green-500 hover:bg-green-600 text-white rounded-md transition-colors text-sm font-bold shadow-md"
                                >
                                    Guardar Ubicación
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ModalMapeo;